import { useAppTheme } from "@hooks/useAppTheme";
import { Box } from "@memorang/ui";
import { Text } from "react-native-paper";
import type { ProethicaProgressData } from "../helpers/proethica-progress-data";
import { IconAvatar } from "./Progress/IconAvatar";

type Props = Pick<
	ProethicaProgressData["completion"],
	"doneCount" | "totalCount"
>;

export const LearningPathHeader = ({ doneCount, totalCount }: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			paddingVertical={18}
			paddingHorizontal={20}
			style={{
				gap: 12,
				backgroundColor: theme.colors.surface,
				borderBottomWidth: 1,
				borderBottomColor: theme.colors.outlineVariant,
			}}
		>
			<IconAvatar
				icon="format-list-checks"
				background={theme.colors.primaryContainer}
				color={theme.colors.primary}
			/>
			<Box flex={1} style={{ gap: 2 }}>
				<Text
					variant="titleSmall"
					style={{ color: theme.colors.onSurface, fontWeight: "700" }}
				>
					Your learning path
				</Text>
				<Text
					variant="bodySmall"
					style={{ color: theme.colors.onSurfaceVariant, fontSize: 12 }}
				>
					{doneCount} of {totalCount} modules complete
				</Text>
			</Box>
		</Box>
	);
};
